import { useEffect, useState, useCallback } from 'react';
import Swal from 'sweetalert2';
import API_CIFRA from '../../config/Variables_apis';
import { tokenManager } from '../../config/authConfig';
import PanelShell from './PanelShell';
import '../../styles/Panel.css';

const cabecerasJson = () => ({
  'Content-Type': 'application/json',
  Authorization: `Bearer ${tokenManager.getAccessToken()}`,
});

/**
 * IPs bloqueadas por incumplir las políticas de uso. El bloqueo real lo aplica
 * el backend (`BloqueoIPMiddleware`) solo si en Configuración → Políticas está
 * activo "Bloquear por IP". Se guardan datos básicos: IP, motivo y fecha.
 */
const BloqueosIP = () => {
  const [bloqueos, setBloqueos] = useState([]);
  const [ip, setIp] = useState('');
  const [motivo, setMotivo] = useState('');
  const [cargando, setCargando] = useState(false);

  const cargar = useCallback(async () => {
    setCargando(true);
    try {
      const r = await fetch(API_CIFRA.configuracion.bloqueos, {
        headers: { Authorization: `Bearer ${tokenManager.getAccessToken()}` },
      });
      if (r.ok) setBloqueos(await r.json());
    } catch {
      /* silencioso */
    } finally {
      setCargando(false);
    }
  }, []);

  useEffect(() => { cargar(); }, [cargar]);

  const agregar = async (e) => {
    e.preventDefault();
    if (!ip.trim()) return;
    try {
      const r = await fetch(API_CIFRA.configuracion.bloqueos, {
        method: 'POST',
        headers: cabecerasJson(),
        body: JSON.stringify({ blo_chIp: ip.trim(), blo_txMotivo: motivo.trim() }),
      });
      if (r.ok) {
        setIp(''); setMotivo('');
        cargar();
      } else {
        Swal.fire({ icon: 'error', title: 'No se pudo bloquear', text: 'Revisa la IP ingresada.' });
      }
    } catch {
      Swal.fire({ icon: 'error', title: 'Error de conexión' });
    }
  };

  const alternar = async (b) => {
    await fetch(API_CIFRA.configuracion.bloqueoDetalle(b.blo_inId), {
      method: 'PATCH',
      headers: cabecerasJson(),
      body: JSON.stringify({ blo_boActivo: !b.blo_boActivo }),
    });
    cargar();
  };

  const eliminar = async (b) => {
    const { isConfirmed } = await Swal.fire({
      icon: 'warning',
      title: '¿Eliminar el bloqueo?',
      html: `Se quitará de la lista la IP <b>${b.blo_chIp}</b>.`,
      showCancelButton: true,
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
    });
    if (!isConfirmed) return;
    await fetch(API_CIFRA.configuracion.bloqueoDetalle(b.blo_inId), {
      method: 'DELETE',
      headers: { Authorization: `Bearer ${tokenManager.getAccessToken()}` },
    });
    cargar();
  };

  return (
    <PanelShell>
      <div className="panel-gu-cabecera">
        <div>
          <h1>Bloqueos por IP</h1>
          <p className="panel-texto-ayuda">
            Bloquea el acceso de quienes incumplan las políticas de uso. El bloqueo solo
            se aplica si está activo <b>“Bloquear por IP”</b> en Configuración → Políticas.
          </p>
        </div>
      </div>

      <form className="panel-bloqueo-form" onSubmit={agregar}>
        <input
          className="panel-input"
          placeholder="Dirección IP (ej. 181.65.10.20)"
          value={ip}
          onChange={(e) => setIp(e.target.value)}
          style={{ maxWidth: 240 }}
        />
        <input
          className="panel-input"
          placeholder="Motivo (opcional)"
          value={motivo}
          onChange={(e) => setMotivo(e.target.value)}
        />
        <button type="submit" className="panel-boton-primario" disabled={!ip.trim()}>
          <i className="fas fa-plus"></i> Bloquear
        </button>
      </form>

      {cargando && <p className="panel-texto-ayuda">Cargando…</p>}
      {!cargando && bloqueos.length === 0 && (
        <p className="panel-texto-ayuda">No hay IPs bloqueadas.</p>
      )}

      <div className="panel-comentarios-lista">
        {bloqueos.map((b) => (
          <div key={b.blo_inId} className="panel-comentario-item">
            <div className="panel-comentario-cabecera">
              <strong>{b.blo_chIp}</strong>
              <span className={b.blo_boActivo ? 'panel-comentario-estado panel-comentario-estado-bloqueado' : 'panel-texto-ayuda'}>
                {b.blo_boActivo ? 'Bloqueada' : 'Inactiva'}
              </span>
            </div>
            <p className="panel-comentario-texto">{b.blo_txMotivo || 'Sin motivo registrado.'}</p>
            <div className="panel-comentario-acciones">
              <span className="panel-texto-ayuda">
                {new Date(b.blo_dtFechaCreated).toLocaleString('es-PE')}
              </span>
              <button type="button" className="panel-boton-secundario" onClick={() => alternar(b)}>
                {b.blo_boActivo ? 'Desactivar' : 'Activar'}
              </button>
              <button type="button" className="panel-boton-secundario panel-boton-peligro" onClick={() => eliminar(b)}>
                Eliminar
              </button>
            </div>
          </div>
        ))}
      </div>
    </PanelShell>
  );
};

export default BloqueosIP;
